import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { CookiesProvider } from '@deerplusofficial/pos-hoc';
import { library } from '@fortawesome/fontawesome-svg-core';
import { Login, Main, Orders, Payments, PageNotFound } from './pages';
import configuredStore from './store';
import icons from './assist/icons';
import registerServiceWorker from './registerServiceWorker';
import './index.css';

class Root extends React.Component {
  render() {
    return (
      <Provider store={configuredStore}>
        <CookiesProvider>
          <Router>
            <Switch>
              <Route path="/orders/:channelId" component={Orders} />
              <Route path="/login/:channelId" component={Login} />
              <Route path="/payments" component={Payments} />
              <Route exact path="/:channelId" component={Main} />
              <Route component={PageNotFound} />
            </Switch>
          </Router>
        </CookiesProvider>
      </Provider>
    );
  }
}

library.add({ ...icons });

ReactDOM.render(<Root />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js